import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function query(_x) {
  return _query.apply(this, arguments);
}

function _query() {
  _query = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: '/invoices',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            return _context.abrupt("return", response);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", _context.t0);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _query.apply(this, arguments);
}

export function get(_x2) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        response,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: parseUrl('invoices', queryParams),
              method: 'GET'
            });

          case 4:
            response = _context2.sent;
            ctx.commit('item', response.data);
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", _context2.t0);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _get.apply(this, arguments);
}

export function save(_x3) {
  return _save.apply(this, arguments);
}

function _save() {
  _save = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(ctx) {
    var queryParams,
        response,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.prev = 1;
            _context3.next = 4;
            return axiosInstance({
              url: '/invoices',
              data: queryParams.data,
              method: 'POST'
            });

          case 4:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            return _context3.abrupt("return", _context3.t0);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 8]]);
  }));
  return _save.apply(this, arguments);
}

export function update(_x4) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(ctx) {
    var queryParams,
        response,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            queryParams = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _context4.prev = 1;
            _context4.next = 4;
            return axiosInstance({
              url: parseUrl('invoices', queryParams),
              data: queryParams.data,
              method: 'PUT'
            });

          case 4:
            response = _context4.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            return _context4.abrupt("return", response);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", _context4.t0);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 10]]);
  }));
  return _update.apply(this, arguments);
}

export function remove(_x5) {
  return _remove.apply(this, arguments);
}

function _remove() {
  _remove = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(ctx) {
    var queryParams,
        response,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            queryParams = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            _context5.prev = 1;
            _context5.next = 4;
            return axiosInstance({
              url: parseUrl('invoices', queryParams),
              data: queryParams.data,
              method: 'DELETE'
            });

          case 4:
            response = _context5.sent;
            ctx.commit('items', response.data.items);
            ctx.commit('pagination', response.data.pagination);
            return _context5.abrupt("return", response);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", _context5.t0);

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 10]]);
  }));
  return _remove.apply(this, arguments);
}

export function cleanItem(_x6) {
  return _cleanItem.apply(this, arguments);
}

function _cleanItem() {
  _cleanItem = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(ctx) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            ctx.commit('item', {});
            return _context6.abrupt("return", true);

          case 5:
            _context6.prev = 5;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", e);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 5]]);
  }));
  return _cleanItem.apply(this, arguments);
}

function parseUrl(state, params) {
  if (state && params.id) {
    return "/".concat(state, "/").concat(params.id);
  }

  return "/".concat(state);
}